import React, { useEffect, useState } from 'react'
import { useFirstRender } from 'hooks'
import { Points, PropertyType, PropertyUse } from './inputs'
import { useStoreActions } from 'store'
import DebtToIncome from './inputs/DebtToIncome'
import CaretUp from './../shared/icons/CaretUp'
import CaretDown from './../shared/icons/CaretDown'

const MoreFiltersToggle = () => {
  const { onClickTracking } = useStoreActions(actions => actions.tracking)
  const [toggle, setToggle] = useState(false)

  const isFirstRender = useFirstRender()

  useEffect(() => {
    if (isFirstRender) {
      return
    }
    const popOverText = `POPOVER ${toggle ? 'OPEN' : 'CLOSED'}`
    onClickTracking({
      element: {
        type: 'button',
        location: 'more button',
        position: 'top',
        text: popOverText,
        name: 'More',
      },
      outcome: popOverText,
    })
    // eslint-disable-next-line
  }, [toggle])

  return (
    <>
      <button
        onClick={() => setToggle(!toggle)}
        data-testid="moreFilters"
        className="display-flex align-items-center justify-content-space-between Button Button--base font-circular-bold p-0 w-full mb-6"
        style={{ fontSize: '16px' }}
      >
        <span>More filters</span>
        {toggle ? (
          <CaretUp extraClasses="Icon Icon--xs fill-blue" />
        ) : (
          <CaretDown extraClasses="Icon Icon--xs fill-blue" />
        )}
      </button>
      {toggle && (
        <>
          <DebtToIncome />
          <Points />
          <PropertyType />
          <PropertyUse />
        </>
      )}
    </>
  )
}

export default MoreFiltersToggle
